import user from './api-users';

export default {
  user,
};



// WEBPACK FOOTER //
// ./src/service/index.js